import { type PropsWithChildren } from 'react'
import classNames from 'classnames'

import styles from './styles.module.scss'

type IPresetFooterProps = PropsWithChildren<{
  className?: string
}>

export const PresetFooter = ({ children, className }: IPresetFooterProps) => (
  <footer className={classNames(styles.footer, className)}>{children}</footer>
)
